'use client';

import { MarkDown } from './atoms/MarkDown';
import IconValue from './atoms/IconValue';

import { getColorScheme } from '@/utils/getColorScheme';
import { getCTA } from '@/utils/getCTA';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';

export default function Recommend(props) {
    const {
        Icon,
        Header,
        Body,
        ColorScheme = 'light-primary',
        VerticalSpacing = 'medium',
    } = props;

    const {
        backgroundColor,
        textColor,
        iconColor,
        thirdButton,
        backgroundStyle,
    } = getColorScheme(ColorScheme, props.GradientDirection);

    const vSpace = getVerticalSpacing(VerticalSpacing);
    const { hasAny: hasCTA, element: CTAButton } = getCTA(
        {
            ...props,
            CustomCTALink: '#',
        },
        {
            primaryVariant: thirdButton,
            buttonAlign: 'justify-center',
            wrapSpacing: 'mt-10 lg:mt-16',
            buttonsClassName: 'flex items-center',
            primaryButtonProps: { className: 'nj-recommendation' },
        }
    );

    return (
        <section
            id="refer"
            className={`editable-component relative ${backgroundColor} px-6 ${vSpace} lg:px-8`}
            style={backgroundStyle}
        >
            <div className="relative z-40 mx-auto max-w-2xl lg:max-w-4xl">
                {/*Section Intro Center Large Paragraph*/}
                <div className="text-center">
                    <IconValue
                        value={Icon}
                        className={`mx-1 mb-6 text-4xl ${iconColor} sm:text-4xl lg:text-6xl`}
                    />
                    <MarkDown
                        variant="h2"
                        className={`font-display text-2xl tracking-tight ${iconColor} md:text-3xl lg:text-4xl`}
                    >
                        {Header}
                    </MarkDown>
                    <MarkDown
                        className={`text-l mt-10 font-text leading-8 ${textColor} sm:text-xl sm:leading-9`}
                    >
                        {Body}
                    </MarkDown>
                </div>

                {/* Regular CTA*/}
                {hasCTA && CTAButton}
            </div>
        </section>
    );
}
